import React from 'react';
import {Provider} from "react-redux";
import configure from "../../store/configure";
import JoinSelectHostingContainer from "./container/JoinSelectHostingContainer";

const JoinSelectHostingPage = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const kko = searchParams.get("kko");
    const code = searchParams.get("code");

    const kToken = searchParams.get("kToken");

    const jToken = searchParams.get("jToken");
    const tMail  = searchParams.get("tMail");
    const tMms   = searchParams.get("tMms");

    return (
        <Provider store={configure}>
            <JoinSelectHostingContainer
                // kko={kko}
                // code={code}

                kToken={kToken}

                jToken={jToken}
                tMail={tMail}
                tMms={tMms}
            />
        </Provider>
    )
};

export default JoinSelectHostingPage;
